import { render } from "./Gmb.vue?vue&type=template&id=024e74ba"
import script from "./Gmb.vue?vue&type=script&lang=js"
export * from "./Gmb.vue?vue&type=script&lang=js"

import "./Gmb.vue?vue&type=style&index=0&id=024e74ba&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__